// extracted by mini-css-extract-plugin
export default {"deleteBtn":"deleteButton_deleteBtn__B8Ckg"};